import React from 'react';
import { ReactComponent as Logo } from '../../assets/images/LOGO.svg';

import './SecondScreenFrame.scss';
import TillTopMenu from '../Header/TopMenu/components/TillTopMenu';

interface SecondScreenFrameProps {
  children: React.ReactNode
}

function SecondScreenFrame({ children } : SecondScreenFrameProps) {

  return (
    <>
      <header className="second-screen-frame">
        <Logo className="second-screen-frame__logo" />
        <TillTopMenu isSecondScreen />
      </header>
      { children }
    </>
  );
}

export default SecondScreenFrame;
